import { useDispatch, useSelector } from "react-redux";
import { 
  setModalOpen, 
  selectNotificationPermission,
  setHasDeviceToken,
  setPermissionStatus 
} from "../stores/notificationPermission";
import { checkDeviceTokenAvailability } from "../utils/notificationPermissionUtils";

/**
 * Hook to manage notification permissions and device token state
 */
export const useNotificationPermissions = () => {
  const dispatch = useDispatch();
  const state = useSelector(selectNotificationPermission);

  const showModal = () => {
    dispatch(setModalOpen(true));
  };

  const hideModal = () => {
    dispatch(setModalOpen(false));
  };

  const checkToken = () => {
    const hasToken = checkDeviceTokenAvailability();
    dispatch(setHasDeviceToken(hasToken));
    dispatch(setPermissionStatus(Notification.permission));
    return hasToken;
  };

  const requestPermission = async () => {
    try {
      const permission = await Notification.requestPermission();
      dispatch(setPermissionStatus(permission));
      
      if (permission === 'granted') {
        // Trigger OneSignal initialization or re-check
        const event = new CustomEvent('notification-permission-granted');
        window.dispatchEvent(event);
      }
      
      return permission;
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      return 'denied';
    }
  };

  return {
    ...state,
    showModal,
    hideModal,
    checkToken,
    requestPermission
  };
};